import * as React from "react"
import { useReadPasswordResetQuery } from "@digits-graphql/frontend/graphql-public"

export function useReadPasswordReset(token: string | null) {
  const { data, loading, error } = useReadPasswordResetQuery({
    variables: {
      resetToken: token || "",
    },
    fetchPolicy: "cache-first",
    context: { publicAPI: true },
    skip: !token,
  })

  const isInvalid = data?.readPasswordReset.isValid === false || Boolean(error)

  return React.useMemo(
    () => ({ contact: data?.readPasswordReset.contact, loading, isInvalid }),
    [data, loading, isInvalid]
  )
}
